"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionTokenToJSON = exports.SessionTokenFromJSONTyped = exports.SessionTokenFromJSON = void 0;
const runtime_1 = require("../runtime");
function SessionTokenFromJSON(json) {
    return SessionTokenFromJSONTyped(json, false);
}
exports.SessionTokenFromJSON = SessionTokenFromJSON;
function SessionTokenFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'token': json['token'],
        'id': !runtime_1.exists(json, 'id') ? undefined : json['id'],
    };
}
exports.SessionTokenFromJSONTyped = SessionTokenFromJSONTyped;
function SessionTokenToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'token': value.token,
        'id': value.id,
    };
}
exports.SessionTokenToJSON = SessionTokenToJSON;
//# sourceMappingURL=SessionToken.js.map